// extracted by mini-css-extract-plugin
export default {"permissionsTableWrapper":"userInfoModal_permissionsTableWrapper__Cp+Q5","userInfoModal":"userInfoModal_userInfoModal__yv+LS","userInfoSection":"userInfoModal_userInfoSection__hkgzR"};